module.exports = __webpack_public_path__ + "static/media/crewstudio_app_task.af2d93fc.jpg";